import React, { useEffect, useRef, useState } from "react";
import { LayoutHeaderConfig } from "../../components/MainLayout";
import OrderPageView from "../../components/OrderPage/OrderPageView";
import { getBillingApi } from "../../api";
import { SAMAN_EPAY_URL } from "../../constants";
import { bindActionCreators } from "redux";
import { fetchOrder, fetchPaymentGateways } from "../../store/billing/actions";
import { selectOrder, selectPaymentGateways } from "../../store/billing/reducer";
import { connect } from "react-redux";
import { withRouter } from "react-router";


const RoroOrder = ({ order, fetchOrder, fetchPaymentGateways, paymentGateways, match }) => {
    const [submitting, setSubmitting] = useState(false);
    const [bankFormData, setBankFormData] = useState(null);
    const inputElement = useRef();

    const orderId = match.params.id;

    useEffect(() => {
        fetchOrder(orderId);
        fetchPaymentGateways(orderId);
    }, [orderId])

    useEffect(() => {
        setSubmitting(false);
    }, [order])

    const onPaymentClick = (orderId, paymentGatewayId) => {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        if (paymentGatewayId === "ZarinpalEpay") {
            const payWin = window.open("/w/payment/init?orderId=" + orderId, '_blank');
            const tid = setInterval(() => {
                if (payWin && payWin.closed) {
                    clearInterval(tid);
                    console.log('child window closed')
                    fetchOrder(orderId);
                } else {
                    console.log('child window still open')
                }
            });
        } else {
            getBillingApi().initPayment({ orderId: orderId, paymentGatewayId: paymentGatewayId })
                .then(response => {
                    if (paymentGatewayId === "RoroWalletPay") {
                        window.location.href = response["redirecturl"]
                    } else {
                        setBankFormData(response);
                        setTimeout(() => {
                            inputElement.current.click()
                        }, 500);
                    }
                })
                .catch(() => {
                    setSubmitting(false);
                })
        }
    }


    let inputs = bankFormData && Object.keys(bankFormData).map((key, i) => (
        <input hidden key={i} name={key} defaultValue={bankFormData[key]} />
    ));
    console.log(inputs);
    return <React.Fragment>
        <LayoutHeaderConfig closeable={true} pageTitle="پرداخت" menuEnabled={false} extra={[]} />
        {order && <OrderPageView purchaseTitle="هزینه خرید اشتراک" purchaseInfo={order}
            onPaymentClick={onPaymentClick}
            submitting={submitting}
            paymentGateways={paymentGateways} />}
        {bankFormData && <form action={SAMAN_EPAY_URL} method="POST">
            {inputs}
            <input ref={inputElement} hidden type="submit" />
        </form>

        }
    </React.Fragment>
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchOrder,
        fetchPaymentGateways,
    },
    dispatch);

const mapStateToProps = state => ({
    order: selectOrder(state),
    paymentGateways: selectPaymentGateways(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoroOrder))
